<template>
  <section class="labelling">
      <div class="labelling__content container">
				<div class="labelling__info-container">
					<div class="labelling__description --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
						<h2 class="labelling__title">Private Labelling</h2>
						<div class="labelling__lines">
							<hr class="line-1">
							<hr class="line-2">
						</div>
						<p>
						Onassis offers the most comprehensive private label CBD program available, 
						with more than 100 products (scroll down to see catalog). Our products allows 
						our clients to build consumer confidence in their brands with a full lineup of 
						the most popular and compliant white label CBD and private label CBD products. 
						All of the finished products are backed by high standards of quality, consistency 
						and compliance. One of the products “Footnany” was featured on Oprah and sold 
						50,000 units as a direct result.
						</p>
						<a class="primary-button" href="#">Sign Up to Invest </a>
					</div>
					<img class="labelling__side-img-tablet --fade-in-left --delay-1" data-vertical-ivp-class="--animate" src="../assets/labelling/research-img-tab.jpg" alt="Research image">
					<img class="labelling__side-img --fade-in-left --delay-1" data-vertical-ivp-class="--animate" src="../assets/labelling/research-img.jpg" alt="Research image">
				</div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'Labelling',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/labelling.scss";
</style>
